// extracted by mini-css-extract-plugin
module.exports = {"selectedFavoriteRow":"styles_selectedFavoriteRow__12V1a","deleteContainer":"styles_deleteContainer__Qcvop"};